var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuests(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#202E4A",
    transform: "translate(1.333 2.667)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 9.333v-2a2 2 0 012-2h4a2 2 0 012 2v2h0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 2,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    strokeLinecap: "round",
    d: "M7.333 10.667V9.333a2 2 0 012-2h2a2 2 0 012 2v1.334h0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.333,
    cy: 4.333,
    r: 1.667,
    fill: "#FFF"
  })))));
}
export default SvgGuests;